export enum CmsPermissions {
  VIEW_CMS = "view_cms",
  CREATE_CMS = "create_cms",
  UPDATE_CMS = "update_cms",
  DELETE_CMS = "delete_cms",
  ARCHIVE_CMS = "archive_cms",
}

export const CmsPermissionsText: Record<CmsPermissions, string> = {
  [CmsPermissions.VIEW_CMS]: "View CMS",
  [CmsPermissions.CREATE_CMS]: "Create CMS",
  [CmsPermissions.UPDATE_CMS]: "Update CMS",
  [CmsPermissions.DELETE_CMS]: "Delete CMS",
  [CmsPermissions.ARCHIVE_CMS]: "Archive CMS",
};
